import { render } from "./PublicParticipation.vue?vue&type=template&id=74225c2a&scoped=true"
import script from "./PublicParticipation.vue?vue&type=script&lang=js"
export * from "./PublicParticipation.vue?vue&type=script&lang=js"

import "./PublicParticipation.vue?vue&type=style&index=0&id=74225c2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74225c2a"]])

export default __exports__